import { Component } from "react";
import './filedownload.scss';
import { GlobalStateContext } from 'app/contexts/GlobalStateContext';
import FileDownloadStatus from "./FileDownloadStatus";

class FileDownload extends Component {
    static contextType = GlobalStateContext;
    constructor(props){
        super(props);
        this.state = {
            allJobs: [],
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const { fileDownloadJobIds } = this.context;
        if(fileDownloadJobIds?.length > 0){
            const newJobs = fileDownloadJobIds.filter(jobId => !this.state.allJobs.includes(jobId));
            if(newJobs.length > 0){
                this.setState({
                    allJobs: [...this.state.allJobs, ...newJobs]
                });
            }
        }        
    }

    render() {
        return(
            <div className="file-download">
                {
                    this.state.allJobs.map((jobId, index) => (
                        <FileDownloadStatus key={index} jobId={jobId} fileNumber={(index + 1)} />
                    ))
                }
            </div>
        )                
    }
}

export default FileDownload;